import { NavLink, Outlet } from 'react-router-dom';
import styles from './admin.module.css';

const links = [
  { to: '/admin/users', label: 'Freischaltung' },
  { to: '/admin/matchdays', label: 'Spieltage' },
  { to: '/admin/players', label: 'Kader' },
  { to: '/admin/teams', label: 'Mannschaften' },
  { to: '/admin/predictions', label: 'Tipps erfassen' },
  { to: '/admin/kackhaufen', label: 'Kackhaufen 💩' },
  { to: '/admin/push', label: 'Push-Erinnerung' },
  { to: '/admin/feedback', label: 'Feedback' },
  { to: '/admin/sync', label: 'Sync' },
];

/** Rahmen für alle Admin-Seiten: Überschrift + Sub-Navigation. */
export function AdminLayout() {
  return (
    <>
      <h1>Admin</h1>
      <nav className={styles.subnav}>
        {links.map((l) => (
          <NavLink
            key={l.to}
            to={l.to}
            className={({ isActive }) =>
              isActive ? `${styles.subnavLink} ${styles.subnavLinkActive}` : styles.subnavLink
            }
          >
            {l.label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </>
  );
}
